<mat-card appearance="outlined">
    <div class="linear-progress-container">
        <div class="section-progress" *ngFor="let item of _items; index as i" [class.completed]="item.status === 0"
            [class.error]="item.status === 2" [class.current]="item.current" [class.in-progress]="item.status === 1">            
            <div class="progress-bar">
                <div class="progress-bar-completed" [style.width.%]="getSectionProgress(item)"></div>
            </div>
            <div class="icon-container">
                @if (item.status === 0) {
                <mat-icon class="icon completed-icon" inline="true">check</mat-icon>
                }
                @if (item.status === 1) {
                <mat-icon class="icon in-progress-icon" inline="true">more_horiz</mat-icon>
                }
                @if (item.status === 2) {
                <mat-icon class="icon error-icon" inline="true">priority_high</mat-icon>
                }
            </div>
            <p class="section-label">
                {{ item.name1 }}<br />{{ item.name2 }}
            </p>
        </div>
    </div>
</mat-card>